export default __webpack_public_path__ + "static/media/02_menu.4461b304.svg";